import { graphQlClient } from '@config/graphqlClient';
import PunchSessionAdjustmentGraphQL from '@graphql/punchSessionAdjustment.queries';
import {
  EditPunchSessionExitInput,
  PunchSessionAdjustment,
} from '@models/punchSessionAdjustment.model';

interface GetPunchSessionAdjustmentsByUserResponse {
  getPunchSessionAdjustmentsByUser: PunchSessionAdjustment[];
}

interface EditPunchSessionExitResponse {
  editPunchSessionExit: PunchSessionAdjustment;
}

export const punchSessionAdjustmentService = {
  async getByUser(userId: string): Promise<PunchSessionAdjustment[]> {
    const data: GetPunchSessionAdjustmentsByUserResponse = await graphQlClient.request(
      PunchSessionAdjustmentGraphQL.queries.getPunchSessionAdjustmentsByUser,
      { userId },
    );
    return data.getPunchSessionAdjustmentsByUser || [];
  },

  async editSessionExit(input: EditPunchSessionExitInput): Promise<PunchSessionAdjustment> {
    const data: EditPunchSessionExitResponse = await graphQlClient.request(
      PunchSessionAdjustmentGraphQL.mutations.editPunchSessionExit,
      { input },
    );
    return data.editPunchSessionExit;
  },
};

export default punchSessionAdjustmentService;
